import {
  Box,
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Skeleton,
  Stack,
  Typography,
} from "@mui/material";
import { useAppDispatch, useAppSelector } from "store/appHooks";
import ListingFeatures from "components/listing-detail/listing-features";
import { useState } from "react";
import { LISTING_STATUS } from "constants/general";
import ListingFeaturesOwner from "./listing-features";
import { convertPrice } from "utils/currency.util";
import { ROUTES } from "constants/routes";
import { useNavigate } from "react-router-dom";
import { deleteEquipment } from "slices/dashboardReducer";

const CustomChip = ({ label, val }: any) => (
  <Chip
    sx={{ background: "#F4F4F4" }}
    label={
      <Stack
        direction="row"
        justifyContent="center"
        alignItems="center"
        spacing={1.5}
      >
        <Typography
          sx={{
            fontSize: "13px",
            color: "#323232",
            fontWeight: 500,
            lineHeight: "16px",
          }}
        >
          {label} :
        </Typography>
        <Typography
          sx={{
            fontSize: "13px",
            color: "#323232",
            fontWeight: 500,
            lineHeight: "16px",
          }}
        >
          {val}
        </Typography>
      </Stack>
    }
  />
);

const ListingDetailsInfoOwner = () => {
  const { listingDetailsOwner, loadingDetails }: any = useAppSelector(
    (state) => state.searchListingReducer
  );
  const listingFeatures = listingDetailsOwner?.listing_features?.[0];
  const {
    listing_type,
    user,
    listing_status,
    listing_features,
    listing_configs,
  } = listingDetailsOwner;
  const features = listing_features?.[0] ?? null;
  const configs = listing_configs?.[0] ?? null;
  const approvalPolicy = user?.user_profile_configs?.[0]?.approval_policy_type;
  const [showWholeDesc, setShowWholeDesc] = useState(false);
  const [deleteId, setDeleteId] = useState(0);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const deleteTheEquipment = () => {
    dispatch(
      deleteEquipment({
        id: deleteId,
        callback: () => {
          setDeleteId(0);
          navigate(-1);
        },
      })
    );
  };

  return (
    <Box sx={{ pr: { md: "4%", lg: "4%", xl: "4%", sm: "0%", xs: "0%" } }}>
      <Box
        sx={{
          pl: { md: "2%", lg: "2%", xl: "2%", sm: "4%", xs: "4%" },
          py: "20px",
        }}
      >
        <Typography
          sx={{
            fontSize: "26px",
            fontWeight: 600,
            lineHeight: "31px",
            color: "#323232",
          }}
        >
          {!loadingDetails ? (
            `${listingDetailsOwner?.listing_name}`
          ) : (
            <Skeleton
              variant="rectangular"
              sx={{
                height: "30px",
                width: "100%",
              }}
            />
          )}
        </Typography>
        {!loadingDetails && (
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              pr: "15px",
            }}
          >
            <Box
              sx={{
                height: "32px",
                width: "fit-content",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                px: "15px",
                background: "#F1B724",
                borderRadius: "20px",
                gap: "5px",

                my: "10px",
              }}
            >
              <Typography
                sx={{
                  color: "#FFF",
                  fontSize: "14px",
                  fontWeight: 500,
                }}
              >
                {listing_type === 1 ? "Tractor" : "Attachment"}
              </Typography>
            </Box>
            {listing_status === LISTING_STATUS.UNDER_REVIEW && (
              <Chip
                label="Pending"
                sx={{
                  display: "flex",
                  background: "#FEF6E1",
                  color: "#F1B724",
                }}
              />
            )}
            {listing_status === LISTING_STATUS.REJECTED && (
              <Chip
                label="Rejected"
                sx={{
                  display: "flex",
                  background: "#FFEFED",
                  color: "#D21A00",
                }}
              />
            )}
            {listing_status === LISTING_STATUS.APPROVED && (
              <Chip
                label="Published"
                sx={{
                  display: "flex",
                  background: "#EFFFED",
                  color: "#4EA643",
                }}
              />
            )}
          </Box>
        )}

        <Typography
          sx={{
            fontSize: "16px",
            fontWeight: 500,
            lineHeight: "24px",
            color: "#A2A2A2",

            mb: "15px",
            display: {
              md: "none",
              lg: "none",
              xl: "none",
              sm: "block",
              xs: "block",
            },
          }}
        >
          {!loadingDetails ? (
            <>
              {" "}
              {listingDetailsOwner?.listing_description?.length > 150 &&
              !showWholeDesc
                ? `${listingDetailsOwner?.listing_description.slice(0, 150)}...`
                : listingDetailsOwner?.listing_description}
              {listingDetailsOwner?.listing_description?.length > 150 && (
                <Typography
                  onClick={() => setShowWholeDesc(!showWholeDesc)}
                  component="span"
                  sx={{
                    color: "#307AFF",
                    fontSize: "15px",
                    fontWeight: "400",
                    cursor: "pointer",
                  }}
                >
                  {showWholeDesc ? `Read Less` : `Read More`}
                </Typography>
              )}
            </>
          ) : (
            <Skeleton
              variant="rectangular"
              sx={{
                height: "30px",
                width: "100%",
              }}
            />
          )}
        </Typography>

        <Typography
          sx={{
            fontSize: "16px",
            fontWeight: 500,
            lineHeight: "24px",
            color: "#A2A2A2",

            mb: "15px",
            display: {
              md: "block",
              lg: "block",
              xl: "block",
              sm: "none",
              xs: "none",
            },
          }}
        >
          {!loadingDetails ? (
            <>
              {listingDetailsOwner?.listing_description?.length}
              {listingDetailsOwner?.listing_description?.length > 500 &&
              !showWholeDesc
                ? `${listingDetailsOwner?.listing_description.slice(0, 500)}...`
                : listingDetailsOwner?.listing_description}
              {listingDetailsOwner?.listing_description?.length > 500 && (
                <Typography
                  onClick={() => setShowWholeDesc(!showWholeDesc)}
                  component="span"
                  sx={{
                    color: "#307AFF",
                    fontSize: "15px",
                    fontWeight: "400",
                    cursor: "pointer",
                  }}
                >
                  {showWholeDesc ? `Read Less` : `Read More`}
                </Typography>
              )}
            </>
          ) : (
            <Skeleton
              variant="rectangular"
              sx={{
                height: "30px",
                width: "100%",
              }}
            />
          )}
        </Typography>

        {!loadingDetails && (
          <Box
            sx={{
              display: "flex",
              gap: "10px",
              flexWrap: "wrap",
              overflow: "auto",
            }}
          >
            {listing_type === 2 && (
              <>
                <CustomChip
                  label="Capacity"
                  val={`${listingFeatures.capacity} ${listingFeatures.capacity_unit}`}
                />

                <CustomChip
                  label={`Booking Type`}
                  val={approvalPolicy === 2 ? "Instabook" : "Manual"}
                />
                <CustomChip
                  label={`Service Offered`}
                  val={
                    listingFeatures.offer_delv_pickup ? "Delivery" : "Pickup"
                  }
                />
                <CustomChip label={`Year`} val={features.year} />
                <CustomChip label={`Type`} val={features.attachment_type} />
              </>
            )}
            {listing_type === 1 && (
              <>
                <CustomChip label="HP" val={listingFeatures.horse_power} />
                <CustomChip
                  label={`Booking Type`}
                  val={approvalPolicy === 2 ? "Instabook" : "Manual"}
                />
                <CustomChip
                  label={`Service Offered`}
                  val={
                    listingFeatures.offer_delv_pickup ? "Delivery" : "Pickup"
                  }
                />{" "}
                <CustomChip label={`Year`} val={features.year} />
                <CustomChip
                  label={`Manufacturer`}
                  val={listingDetailsOwner?.manufacturer?.name}
                />
                <CustomChip
                  label={`Model`}
                  val={listingDetailsOwner?.manufacturer_model?.name}
                />
              </>
            )}
          </Box>
        )}
        {loadingDetails && (
          <Box display="flex" gap="10px">
            <Skeleton
              sx={{ height: "50px", borderRadius: "5rem", width: "200px" }}
              variant="rectangular"
            />
            <Skeleton
              sx={{ height: "50px", borderRadius: "5rem", width: "200px" }}
              variant="rectangular"
            />
          </Box>
        )}
      </Box>
      <Box
        sx={{
          display: {
            sm: "block",
            xs: "block",
            md: "none",
            lg: "none",
            xl: "none",
          },
          height: "8px",
          background: "#F7F7F7",
          width: "100%",
        }}
      />
      {!loadingDetails && <ListingFeaturesOwner />}
      {loadingDetails && (
        <Box display="flex" gap="10px" flexWrap="wrap" mt="10px" ml="2%">
          <Skeleton
            sx={{ height: "100px", borderRadius: "10px", width: "100px" }}
            variant="rectangular"
          />
          <Skeleton
            sx={{ height: "100px", borderRadius: "10px", width: "100px" }}
            variant="rectangular"
          />
          <Skeleton
            sx={{ height: "100px", borderRadius: "10px", width: "100px" }}
            variant="rectangular"
          />
          <Skeleton
            sx={{ height: "100px", borderRadius: "10px", width: "100px" }}
            variant="rectangular"
          />
        </Box>
      )}
      <Box
        sx={{
          display: {
            sm: "block",
            xs: "block",
            md: "none",
            lg: "none",
            xl: "none",
          },
          height: "8px",
          background: "#F7F7F7",
          width: "100%",
          mt: "20px",
        }}
      />
      {!loadingDetails && (
        <Box
          sx={{
            px: { md: "2%", lg: "2%", xl: "2%", sm: "4%", xs: "4%" },
            py: "0px",
            mt: "15px",
          }}
        >
          <Typography
            sx={{
              fontWeight: 600,
              fontSize: "18px",
              lineHeight: "31px",
              my: "15px",
            }}
          >
            Other Info
          </Typography>

          <Stack gap="5px">
            <Stack flexDirection="row" justifyContent="space-between">
              <Typography
                sx={{
                  color: "#A2A2A2",
                  fontSize: "15px",
                  fontWeight: 500,
                  lineHeight: "31px",
                }}
              >
                Estimated Marked Value(EMV)
              </Typography>
              <Typography
                sx={{
                  color: "#313232",
                  fontSize: "15px",
                  fontWeight: 600,
                  lineHeight: "31px",
                }}
                textAlign="right"
              >
                {convertPrice(configs?.emv)}
              </Typography>
            </Stack>
            <Stack flexDirection="row" justifyContent="space-between">
              <Typography
                sx={{
                  color: "#A2A2A2",
                  fontSize: "15px",
                  fontWeight: 500,
                  lineHeight: "31px",
                }}
              >
                Usage Rate
              </Typography>
              <Typography
                sx={{
                  color: "#313232",
                  fontSize: "15px",
                  fontWeight: 600,
                  lineHeight: "31px",
                }}
                textAlign="right"
              >
                {configs?.usage_type === 1
                  ? "Allow Unlimited Usage"
                  : "Own Rates"}
              </Typography>
            </Stack>
            {configs?.usage_type !== 1 && (
              <Stack gap="5px" ml="15px">
                <Stack flexDirection="row" justifyContent="space-between">
                  <Typography
                    sx={{
                      color: "#A2A2A2",
                      fontSize: "15px",
                      fontWeight: 500,
                      lineHeight: "31px",
                    }}
                  >
                    Hours
                  </Typography>
                  <Typography
                    sx={{
                      color: "#313232",
                      fontSize: "15px",
                      fontWeight: 600,
                      lineHeight: "31px",
                    }}
                    textAlign="right"
                  >
                    {configs?.custom_hours}
                  </Typography>
                </Stack>
                <Stack flexDirection="row" justifyContent="space-between">
                  <Typography
                    sx={{
                      color: "#A2A2A2",
                      fontSize: "15px",
                      fontWeight: 500,
                      lineHeight: "31px",
                    }}
                  >
                    Excess Hour Fees
                  </Typography>
                  <Typography
                    sx={{
                      color: "#313232",
                      fontSize: "15px",
                      fontWeight: 600,
                      lineHeight: "31px",
                    }}
                    textAlign="right"
                  >
                    {convertPrice(configs?.custom_excess_hours_fee)}
                  </Typography>
                </Stack>
              </Stack>
            )}
            <Stack flexDirection="row" justifyContent="space-between">
              <Typography
                sx={{
                  color: "#A2A2A2",
                  fontSize: "15px",
                  fontWeight: 500,
                  lineHeight: "31px",
                }}
              >
                Price
              </Typography>
              <Typography
                sx={{
                  color: "#313232",
                  fontSize: "15px",
                  fontWeight: 600,
                  lineHeight: "31px",
                }}
                textAlign="right"
              >
                {convertPrice(listingDetailsOwner?.price)}/Day
              </Typography>
            </Stack>
          </Stack>
        </Box>
      )}

      {!loadingDetails && (
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} mt="20px">
          <Box
            sx={{
              display: "flex",
              gap: "15px",
              px: "2%",
            }}
          >
            <Button
              color="error"
              variant="outlined"
              sx={{ borderRadius: "10px", height: "56px" }}
              fullWidth
              onClick={() => setDeleteId(listingDetailsOwner.id)}
            >
              Delete
            </Button>

            <Button
              color="primary"
              variant="contained"
              sx={{ borderRadius: "10px", height: "56px" }}
              fullWidth
              onClick={() =>
                navigate(
                  `${ROUTES.EQUPIMENT_LISTING}?id=${listingDetailsOwner.id}`
                )
              }
              disabled={listing_status === LISTING_STATUS.PENDING}
            >
              Edit Details
            </Button>
          </Box>
        </Grid>
      )}

      {deleteId > 0 && (
        <Dialog
          open
          onClose={() => setDeleteId(0)}
          PaperProps={{ style: { padding: "20px", borderRadius: "20px" } }}
        >
          <DialogTitle>Are you sure?</DialogTitle>
          <DialogContent>
            <Typography>
              You want to delete this Listing, This action cannot be undone.
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button
              color="primary"
              variant="outlined"
              sx={{ borderRadius: "10px", height: "48px" }}
              fullWidth
              onClick={() => setDeleteId(0)}
            >
              Cancel
            </Button>

            <Button
              color="error"
              variant="contained"
              sx={{ borderRadius: "10px", height: "48px" }}
              fullWidth
              onClick={deleteTheEquipment}
            >
              Yes Delete
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </Box>
  );
};

export default ListingDetailsInfoOwner;
